// extracted by mini-css-extract-plugin
module.exports = {"OrgLoadingBase":"OrgLoading_OrgLoadingBase__BUbhJ","OrgLoadingIcon":"OrgLoading_OrgLoadingIcon__3IrFl"};